import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    height: 100%;
    --p-file-border: var(--p-border);
  }

  .file {
    border: 1px solid var(--p-file-border);
    border-radius: var(--p-file-border-radius, 3px);
    padding: var(--p-file-padding, 10px);
    cursor: pointer;
    background-color: var(--p-boxed-bg);
    height: 100%;
    position: relative;
  }

  .file:hover:not(.selected) {
    box-shadow: 0 0 0 2px var(--p-file-border);
    z-index: 1;
  }
  .file:focus-visible {
    z-index: 1;
  }

  /**
--------------------------------------------------
* Selected
--------------------------------------------------
*/
  .selected {
    /* background: var(--p-brand-active-bg); */
    border-color: var(--p-brand);
    box-shadow: 0 0 0 2px var(--p-brand);
  }

  /**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
  .preview {
    aspect-ratio: 1/1;
    position: relative;
  }

  .preview img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    z-index: 1;
    position: relative;
  }

  .transparent .preview::after {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill-opacity='.15'><path d='M50 0h50v50H50zM0 50h50v50H0z'/></svg>");
    background-size: 10px 10px;
    background-repeat: repeat;
    background-color: rgba(0, 0, 0, 0.15);
  }

  .icon img {
    max-width: 40%;
    filter: grayscale(1) invert(var(--p-dark-mode));
    opacity: 0.4;
    margin: auto;
  }

  .video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    color: white;
    transform: translate(-50%, -50%);
    z-index: 7;
    width: var(--p-file-icon-play-size, 24px);
    height: var(--p-file-icon-play-size, 24px);
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /**
--------------------------------------------------
* Info
--------------------------------------------------
*/
  .info {
    padding-top: 4px;
  }

  .name {
    font-size: var(--p-file-name-font-size, 1rem);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }

  .type {
    font-size: 0.75rem;
    text-transform: uppercase;
    padding: 3px 5px;
    border-radius: 3px;
    background-color: var(--p-text-color-contrast-100);
    line-height: 1;
    border: 1px solid var(--p-border);
    opacity: 1;
    display: inline-block;
  }

  .info-bottom {
    font-size: 0.875rem;
  }

  .size {
    opacity: var(--p-text-meta-opacity);
  }

  .info-meta {
    font-size: 0.875rem;
    line-height: 1.2;
    opacity: var(--p-text-meta-opacity);
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .selectable .info-top {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 4px;
  }

  .info-top p-checkbox {
    margin-top: 2px;
    --p-input-margin-bottom: 0;
  }

  .info-bottom {
    margin-top: 4px;
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  /**
--------------------------------------------------
* Grid small
--------------------------------------------------
*/
  .layout-grid-small {
    --p-file-padding: 8px;
    --p-file-name-font-size: 0.875rem;
  }

  /**
--------------------------------------------------
* List
--------------------------------------------------
*/

  .file-list {
    display: grid;
    grid-template-columns: var(--p-list-grid-template-columns);
    gap: var(--p-file-list-gap, 10px);
    align-items: center;
    border-radius: 0;
    padding: var(--p-file-list-padding, 4px 10px);
    border-top: none;
    --p-file-name-font-size: 0.875rem;
    --p-file-icon-play-size: 14px;
  }

  .file-list:hover:not(.selected) {
    box-shadow: inset 0 0 0 1px var(--p-file-border);
  }

  .list-col {
    font-size: 0.875rem;
  }

  /**
--------------------------------------------------
* Masonry
--------------------------------------------------
*/

  .file-masonry {
    border: none;
    padding: 0;
    border-radius: 0;
    margin-bottom: var(--p-file-masonry-gap, 20px);
    break-inside: avoid-column;
    position: relative;
    overflow: hidden;
    color: var(--p-text-color-light);
    --p-gradient-stop-2: 22%;
    --p-gradient-stop-3: 42%;
    --p-border: var(--p-border-dark);
    --p-text-color-contrast-100: var(--p-text-color-light-contrast-100);
  }

  .file-masonry:hover:not(.selected) {
    box-shadow:
      0 0 0 2px var(--p-section-bg),
      0 0 0 4px var(--p-file-border);
    z-index: 1;
  }

  .file-masonry .preview {
    aspect-ratio: unset;
  }

  .file-masonry.icon {
    aspect-ratio: 3/2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file-masonry-info {
    padding: 1rem;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .file-masonry-info::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 250px;
    z-index: -1;
    background: linear-gradient(
      0deg,
      rgb(0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) var(--p-gradient-stop-2),
      transparent var(--p-gradient-stop-3),
      transparent 100%
    );
  }

  .file-masonry-info-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.875rem;
    opacity: var(--p-text-meta-opacity);
  }

  .file-masonry-meta-item::before {
    content: '·';
    margin: 0 0.35rem;
  }

  .file-masonry-meta-item:first-child::before {
    display: none;
  }
`;
